import { useState } from 'react';
import { JFormik, sortString } from '@centerpiece/components';
import * as Yup from 'yup';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  useGetTeamsQuery,
  useDeleteTeamMutation,
  useUpdateTeamMutation,
  useCreateTeamMutation,
} from 'store/api';

export const TeamsTab = () => {
  const [editing /*, setEditing*/] = useState<boolean>(false);
  const { data: teams = [], isLoading } = useGetTeamsQuery({});
  const [createTeam] = useCreateTeamMutation();
  const [editTeam] = useUpdateTeamMutation();
  const [deleteTeam] = useDeleteTeamMutation();
  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <JFormik
      initialValues={() => ({
        teams: [...(teams || [])].sort((a, b) => sortString(a.name, b.name)),
      })}
      handleSubmit={async (values, formik) => {}}
      loading={isLoading}
      validationSchema={
        editing
          ? Yup.object({
              name: Yup.string().required('Project name is required'),
              // team: Yup.object().nullable().required('Project team is required'),
            })
          : Yup.object({})
      }
      disabled={!editing}
      form={[
        {
          name: 'teams',
          itemType: 'table_array',
          label: 'Teams',
          jItemProps: {
            addLabel: 'Add Team',
          },
          tableProps: {
            onCreate: (values: any) => createTeam(values),
            onEdit: (values: any) => editTeam(values),
            onDelete: (id: number) => deleteTeam(id),
            readOnly: (values: any) =>
              values?.subscription === undefined && values?.id > 0,
            // headers: [
            //   {
            //     name: 'name',
            //     label: 'Team *',
            //     itemType: 'textfield',
            //     jItemProps: {
            //       width: '100%',
            //       sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
            //     },
            //     gridProps: { xs: 12 },
            //   },
            //   // {
            //   //   name: 'target_gmr',
            //   //   label: "Target GMR *",
            //   //   itemType: 'textfield',
            //   //   jItemProps: { team: 'number' },
            //   //   gridProps: { xs: 12 },
            //   // },
            // ],
            columns: [
              {
                name: 'name',
                label: 'Team *',
                itemType: 'textfield',
                jItemProps: {
                  width: '100%',
                  sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
                },
                gridProps: { xs: 12 },
              },
              // {
              //   name: 'target_gmr',
              //   label: "Target GMR *",
              //   itemType: 'textfield',
              //   jItemProps: { team: 'number' },
              //   gridProps: { xs: 12 },
              // },
            ],
          },
          device: downSm ? 'mobile' : 'desktop',
        },
      ]}
    />
  );
};
